module.exports = __webpack_public_path__ + "static/media/alfa1.dccac6b6.jpg";